import React from "react";
import bannerImg from "../../Assets/products-banner.svg";
import "./StaticBanner.css";

const StaticBanner = () => {
  return (
    <section className="swrapper">
      <img src={bannerImg} alt="banner" className="sbanner-img" />
    </section>
  );
};

export default StaticBanner;
